// extracted by mini-css-extract-plugin
export default {"actionCard":"acctionMessage_actionCard__55nwD","icon":"acctionMessage_icon__gMFvT","content":"acctionMessage_content__V-2Nu","switch":"acctionMessage_switch__Lz3UC"};